import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { blogPosts } from '../data/mock';
import { useLang } from '../context/LanguageContext';

export default function BlogSection({ limit = 3, showHeader = true }) {
  const { t } = useLang();
  const list = blogPosts.slice(0, limit);
  return (
    <section className="py-24 bg-[#faf6ec]">
      <div className="max-w-[1280px] mx-auto px-6">
        {showHeader && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-end mb-12">
            <div>
              <p className="section-eyebrow mb-4">{t('blog.eyebrow')}</p>
              <h2 className="text-[36px] md:text-[44px] leading-[1.1] font-extrabold text-[#14110f]">
                {t('blog.titlePre')} <span className="text-[#f5b300]">{t('blog.titleAccent')}</span>
              </h2>
            </div>
            <div className="flex flex-col lg:items-end gap-5">
              <p className="text-[15.5px] text-neutral-600 leading-relaxed max-w-md lg:text-right">{t('blog.desc')}</p>
              <Link
                to="/blog"
                className="inline-flex items-center gap-2 bg-[#f5b300] hover:bg-[#e0a200] text-[#14110f] font-semibold px-6 py-3 rounded-md shadow-[0_10px_28px_-10px_rgba(245,179,0,0.7)] hover:-translate-y-0.5 transition-all w-fit"
              >
                <ArrowUpRight className="w-4 h-4" /> {t('cta.allArticles')}
              </Link>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {list.map((p) => {
            const catKey = `blog.cat.${p.category.toLowerCase()}`;
            return (
            <article key={p.id} className="group rounded-xl overflow-hidden bg-white shadow-[0_18px_45px_-25px_rgba(20,17,15,0.18)] hover:shadow-[0_25px_60px_-25px_rgba(20,17,15,0.35)] hover:-translate-y-1.5 transition-all">
              <div className="relative h-56 overflow-hidden">
                <img src={p.image} alt={t(`blog.${p.slug}.title`)} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute top-4 left-4 bg-[#f5b300] text-[#14110f] rounded-md px-3 py-2 text-center shadow-md">
                  <p className="text-[18px] font-extrabold leading-none">{p.date.day}</p>
                  <p className="text-[10px] uppercase tracking-wider font-semibold">{p.date.month}</p>
                </div>
              </div>
              <div className="p-7">
                <div className="flex items-center gap-3 text-[12px] text-neutral-500 mb-3">
                  <span className="text-[#c89200] uppercase tracking-wider font-bold">{t(catKey)}</span>
                  <span>·</span>
                  <span>{p.author}</span>
                </div>
                <h3 className="text-[19px] font-bold text-[#14110f] group-hover:text-[#c89200] transition-colors leading-snug">
                  {t(`blog.${p.slug}.title`)}
                </h3>
                <p className="mt-3 text-[14px] text-neutral-500 leading-relaxed">{t(`blog.${p.slug}.excerpt`)}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-[13.5px] font-semibold uppercase tracking-wide text-[#c89200]">
                  {t('cta.readArticle')} <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-0.5 transition-transform" />
                </span>
              </div>
            </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
